'use strict';

export const ScrollEffect = (el)=>{
	const observer = new IntersectionObserver((entries)=>{
		entries.forEach((entry)=>{
			if( entry.isIntersecting || entry.boundingClientRect.y < 0 ) {
				el.classList.add('is-visible');
				observer.unobserve(el);
			}
		});
	}, {
		rootMargin: '0% 0% -15% 0%'
	});
	observer.observe(el);
};